import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './duplicityinfo.styl'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import config from 'config'

export default class DuplicityInfo extends Component {
  static propTypes = {
    data: PropTypes.string
  }

  static defaultProps = {
    data: {}
  }

  render () {
    const {
      data
    } = this.props

    const duplicities = data && JSON.parse(data).duplicities
    const size = duplicities.length

    return (
      <div className={`${styles.duplicityInfo}`}>
        <FormattedMessage
          id='label.duplicity_warning'
          defaultMessage={<span>Warning: Name and DoB same as:</span>}
        /><br />
        <div className={`${styles.list}`}>
          {duplicities && duplicities.map((d, index) => (
            <span><Link
              to={`${config.publicPath}/participants/${d.participantId}`}>{d.participantGlobalId}</Link> {(index < size - 1) ? ' , ' : ''}</span>
          ))}
        </div>
      </div>
    )
  }
}
